import React, { useEffect, useState } from 'react';
import axiosInstance from '../api/axiosInstance';
import TiptapEditor from '../components/TiptapEditor';


const AdminContentEditor = () => {
  const [items, setItems] = useState([]);
  const [selectedKey, setSelectedKey] = useState('');
  const [form, setForm] = useState({
    title: '',
    url: '',
    type: 'page',
    content: '',
    contentType: 'html',
    published: false
  });
  const [message, setMessage] = useState(null);
  const [newKey, setNewKey] = useState('');
  const [creating, setCreating] = useState(false);

  useEffect(() => {
    fetchItems();
  }, []);

  const fetchItems = () => {
    axiosInstance.get('/content')
      .then(res => setItems(res.data));
  };

  const handleSelect = (key) => {
    setSelectedKey(key);
    const item = items.find(i => i.key === key);
    if (item) {
      setForm({
        title: item.title || '',
        url: item.url || '',
        type: item.type || 'page',
        content: item.content || '',
        contentType: item.contentType || 'html',
        published: item.published || false
      });
    }
  };

  const handleSave = () => {
    axiosInstance.put(`/content/${selectedKey}`, form)
      .then(() => {
        setMessage({ type: 'success', text: 'Seite gespeichert!' });
        fetchItems();
      })
      .catch(() => {
        setMessage({ type: 'error', text: 'Fehler beim Speichern.' });
      });
  };

  const handleCreate = () => {
    if (!newKey) return;
    setCreating(true);
    axiosInstance.put(`/content/${newKey}`, {
      key: newKey,
      title: 'Neue Seite',
      url: `/${newKey}`,
      type: 'page',
      content: '',
      contentType: 'html',
      published: false
    }).then(() => {
      setNewKey('');
      setSelectedKey(newKey);
      fetchItems();
    }).finally(() => setCreating(false));
  };

  return (
    <div className="max-w-4xl mx-auto p-4">
      <h2 className="text-2xl font-bold mb-6">Seitenverwaltung</h2>

      {message && (
        <div className={`alert mb-4 ${message.type === 'success' ? 'alert-success' : 'alert-error'}`}>
          {message.text}
        </div>
      )}

      {!selectedKey && (
        <div className="card bg-base-100 shadow p-4 mb-6">
          <h3 className="font-bold mb-2">Neue Seite anlegen</h3>
          <input
            type="text"
            className="input input-bordered w-full mb-2"
            placeholder="Technischer Schlüssel (z. B. datenschutz)"
            value={newKey}
            onChange={(e) => setNewKey(e.target.value.toLowerCase())}
          />
          <button
            className="btn btn-primary"
            onClick={handleCreate}
            disabled={!newKey || creating}
          >
            ➕ Anlegen
          </button>
        </div>
      )}

      <div className="mb-4">
        <label className="label">Seite auswählen</label>
        <select
          className="select select-bordered w-full"
          value={selectedKey}
          onChange={(e) => handleSelect(e.target.value)}
        >
          <option value="">-- Seite wählen --</option>
          {items.map(item => (
            <option key={item.key} value={item.key}>{item.title}</option>
          ))}
        </select>
      </div>

      {selectedKey && (
        <div className="card bg-base-100 shadow p-4 space-y-4">
          <div>
            <label className="label">Titel</label>
            <input
              className="input input-bordered w-full"
              value={form.title}
              onChange={(e) => setForm({ ...form, title: e.target.value })}
            />
          </div>

          <div>
            <label className="label">URL (z. B. /datenschutz)</label>
            <input
              className="input input-bordered w-full"
              value={form.url}
              onChange={(e) => setForm({ ...form, url: e.target.value })}
            />
          </div>

          <div>
            <label className="label">Typ</label>
            <select
              className="select select-bordered w-full"
              value={form.type}
              onChange={(e) => setForm({ ...form, type: e.target.value })}
            >
              <option value="page">Seite</option>
              <option value="module">Modul</option>
            </select>
          </div>

          <div>
            <label className="label">Veröffentlicht</label>
            <input
              type="checkbox"
              className="toggle"
              checked={form.published}
              onChange={(e) => setForm({ ...form, published: e.target.checked })}
            />
          </div>

          <div>
            <label className="label">Inhalt</label>
            <TiptapEditor
  content={form.content}
  onChange={(val) => setForm({ ...form, content: val })}
/>
          </div>

          <button className="btn btn-primary mt-4" onClick={handleSave}>💾 Speichern</button>
        </div>
      )}
    </div>
  );
};

export default AdminContentEditor;
